/* The tabs live apart from the view: the route's `validateSearch` imports the guard, and importing
 * it from call-detail-view.tsx pulled the view, call-back button and telephony SDK into the
 * router's entry chunk. */
export type DetailTab =
  | "summary"
  | "messages"
  | "recording"
  | "transfer"
  | "transcript"
  | "history";

const DETAIL_TABS: readonly DetailTab[] = [
  "summary",
  "messages",
  "recording",
  "transfer",
  "transcript",
  "history",
];

export const isDetailTab = (value: unknown): value is DetailTab =>
  typeof value === "string" && (DETAIL_TABS as readonly string[]).includes(value);
